// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_ha","advertCardNum":"c-a_hb"};